import { View, Image } from 'react-native';
import { Text } from '@/components/Text';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import openURL from '../../../utils/openLink';
import constants from '@/config/constants';

function ProductInformations() {
  return (
    <View className="flex-1 flex-row w-full justify-between items-center px-4">
      <View className="flex-col justify-between">
        <View className="w-12">
          <Image
            className="w-full"
            resizeMode="contain"
            source={require('../../../assets/ce2.png')}
          />
        </View>
        <View>
          <Text className="text-base font-semibold">
            App Version {constants.appVersion}
          </Text>
          <Text className="text-base font-semibold">
            UDI-DI {constants.udiDi}
          </Text>
          <Text className="text-base font-semibold">
            UDI-PI {constants.udiPi()}
          </Text>
        </View>
      </View>
      <PressableNeolexon
        onPress={() => openURL('https://neolexon.de/impressum/')}
      >
        <Text className="text-lg font-semibold">Impressum</Text>
      </PressableNeolexon>
    </View>
  );
}

export default ProductInformations;
